import React, { useEffect, useState, useRef } from "react";
import { Container } from "@material-ui/core";

import { apiErrorsToFormik } from "utils/errors";
import { appRoutes } from "routes";
import { useSubscriptions, useLoading, useRouter, useUsers } from "hooks";
import { attributesToSubmit } from "forms/UpdateCreditCardForm";
import AccountLayout from "layouts/AccountLayout";

import Form from "./components/Form";
import useStyles from "./useStyles";

const UpdateCreditCard = () => {
  const classes = useStyles();
  const [error, setError] = useState(null);
  const [billingInfo, setBillingInfo] = useState({});

  const { history } = useRouter();
  const subscriptionRef = useRef(null);
  const { loadCurrentUser } = useUsers();
  const { getBillingInfo, updateBillingInfo } = useSubscriptions();
  const { func: getCurrentBillingInfoWithLoader, isPending: isCurrentBillingInfoPending } = useLoading(getBillingInfo);
  const { func: updateBillingInfoWithLoader, isPending } = useLoading(updateBillingInfo);
  const { func: loadCurrentUserWithLoader, isPending: isCurrentUserPending } = useLoading(loadCurrentUser);

  useEffect(() => {
    getCurrentBillingInfoWithLoader().then((currentBillingInfo) => {
      setBillingInfo(currentBillingInfo);
    });
  }, []);

  const handleSubscriptionChange = (subscription) => {
    subscriptionRef.current = subscription;
  };

  const handleSubscribe = async () => {
    setError(null);
    const params = attributesToSubmit(subscriptionRef.current);
    try {
      await updateBillingInfoWithLoader(params);
      await loadCurrentUserWithLoader();
      history.push(appRoutes.subscriptionDetailsPath());
    } catch (err) {
      setError(apiErrorsToFormik(err));
    }
  };

  return (
    <AccountLayout
      title="eCards - Customize & Send Funny Greeting Cards Online - JibJab"
      backLink={appRoutes.subscriptionDetailsPath()}
    >
      <div className={classes.root}>
        <Container>
          <Form
            billingInfo={billingInfo}
            error={error}
            isPending={isPending || isCurrentUserPending || isCurrentBillingInfoPending}
            onSubscriptionChange={handleSubscriptionChange}
            onSubscribe={handleSubscribe}
          />
        </Container>
      </div>
    </AccountLayout>
  );
};

export default UpdateCreditCard;
